import {
  getActiveFormattingMask,
  guessCountryByPartialPhoneNumber,
} from 'react-international-phone';

// Formats an E.164 phone number for display (read-only), e.g.
// "+380671234567" → "+380 (67) 123 45 67", "+12025550123" → "+1 (202) 555-0123".
// Reuses the country data / masks already shipped with react-international-phone,
// so it stays in sync with PhoneTextField and new countries work for free.
export const formatPhoneNumber = (value: string | null | undefined): string => {
  if (!value) return '';

  const guess = guessCountryByPartialPhoneNumber({ phone: value });
  if (!guess.country) return value;

  const dialCode = guess.country.dialCode;
  const nationalDigits = value.replace(/\D/g, '').slice(dialCode.length);
  const mask = getActiveFormattingMask({ phone: value, country: guess.country });

  let index = 0;
  const formatted = mask.replace(/\./g, () => nationalDigits[index++] ?? '');

  return `+${dialCode} ${formatted}`.trim();
};
